import { gql, LazyQueryHookOptions, TypedDocumentNode, useLazyQuery } from "@apollo/client";

import {
  GetShortScenarioQuery,
  GetShortScenarioQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { shortScenarioFragment } from "src/graphql/anti-fraud/fragments/ShortScenarioFragment.ts";

export const getShortScenarioQuery = gql`
  query getShortScenario($id: ID!) {
    scenario(id: $id) {
      ...ShortScenarioFragment
    }
  }

  ${shortScenarioFragment}
` as TypedDocumentNode<GetShortScenarioQuery, GetShortScenarioQueryVariables>;

export const useGetShortScenarioLazyQuery = (
  options?: LazyQueryHookOptions<GetShortScenarioQuery, GetShortScenarioQueryVariables>
) => {
  return useLazyQuery(getShortScenarioQuery, options);
};
